// Example innovative features for demo mode
import { 
  Brain, 
  Coins, 
  Fingerprint, 
  Zap, 
  Globe, 
  Award,
  Microscope,
  Shield
} from 'lucide-react';

export const exampleInnovativeFeatures = [
  {
    id: 'zero-knowledge',
    icon: Shield,
    title: 'Zero-Knowledge Health Proofs',
    description: 'Prove your health status without revealing sensitive data',
    details: 'Cryptographic proofs allow you to verify health credentials to employers or insurers without exposing your actual medical records.',
    status: 'beta',
  },
  {
    id: 'ai-insights',
    icon: Brain,
    title: 'Privacy-Preserving AI Analysis',
    description: 'Get AI health insights while keeping your data private',
    details: 'Advanced federated learning provides personalized health recommendations without your data ever leaving your device.',
    status: 'active',
  },
  {
    id: 'health-tokens',
    icon: Coins,
    title: 'Health Data Marketplace',
    description: 'Earn tokens by contributing to medical research',
    details: 'Participate in research studies and earn cryptocurrency rewards while maintaining complete anonymity and control.',
    status: 'coming-soon',
  },
  {
    id: 'biometric-auth',
    icon: Fingerprint,
    title: 'Biometric Blockchain Identity',
    description: 'Secure access using your unique biometric signature',
    details: 'Combine fingerprint, face, and voice recognition with blockchain for ultimate security and convenience.',
    status: 'beta',
  },
  {
    id: 'quantum-encryption',
    icon: Zap,
    title: 'Quantum-Resistant Encryption',
    description: 'Future-proof security against quantum computers',
    details: 'Post-quantum cryptographic algorithms ensure your data remains secure even against future quantum threats.',
    status: 'development',
  },
  {
    id: 'global-interop',
    icon: Globe,
    title: 'Global Health Passport',
    description: 'Universal health record recognized worldwide',
    details: 'Cross-border compatible health credentials that work with any healthcare system globally.',
    status: 'active',
  },
  {
    id: 'smart-contracts',
    icon: Award,
    title: 'Automated Health Agreements',
    description: 'Smart contracts for insurance and care coordination',
    details: 'Blockchain-based agreements that automatically execute based on your health data and predefined conditions.',
    status: 'beta',
  },
  {
    id: 'predictive-health',
    icon: Microscope,
    title: 'Predictive Health Analytics',
    description: 'AI predicts health risks before symptoms appear',
    details: 'Machine learning models analyze patterns to predict potential health issues weeks or months in advance.',
    status: 'development',
  },
]; 